// Permission utility for checking menu/action access
// Usage: canAccess({ user, permissions, module, page, action })
// Backward compatible with old 'menu' parameter

export function canAccess({ user, permissions, module, page, menu, action }) {
  if (!user || !user.role) return false;
  if (user.role === 'ADMIN') return true;
  if (user.role !== 'EMPLOYEE') return false;
  if (!permissions || !Array.isArray(permissions)) return false;
  
  // Support both old (menu) and new (module/page) structure
  // If 'menu' is provided (old), use it as 'page' and default module to 'ADMIN'
  const checkModule = module || 'ADMIN';
  const checkPage = page || menu;
  
  // permissions: [{ module, page, action, allow }]
  return permissions.some(
    (perm) => 
      perm.module === checkModule && 
      perm.page === checkPage && 
      perm.action === action && 
      perm.allow === 1
  );
}
